import React, { useState, useEffect } from 'react';
import { FaWifi } from 'react-icons/fa';

const OfflineIndicator = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      setDismissed(false);
    };
    const handleOffline = () => {
      setIsOffline(true);
      setDismissed(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOffline || dismissed) return null;

  return (
    <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-[9999] bg-amber-600 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-3 text-sm max-w-md">
      <FaWifi className="text-white opacity-70 flex-shrink-0" />
      <span>You're offline — cart changes will sync when reconnected</span>
      <button
        onClick={() => setDismissed(true)}
        className="ml-2 text-white/80 hover:text-white font-bold flex-shrink-0"
      >
        ✕
      </button>
    </div>
  );
};

export default OfflineIndicator;
